/**
 * Project: Gus's Auto Dealership
 * Author: Eihab Khudhair
 * Description: Hook for Ctrl+Alt+G admin shortcut
 */

'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';

export function useAdminShortcut() {
  const router = useRouter();

  // Hold anywhere for 3 seconds to open admin login
  const holdTimerRef = useRef<number | null>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for
      if (event.ctrlKey && event.altKey && event.key.toLowerCase() === 'g') {
        event.preventDefault();
        router.push('/admin/login');
      }
    };

  const handlePointerDown = () => {
    if (holdTimerRef.current) {
      window.clearTimeout(holdTimerRef.current);
    }

    holdTimerRef.current = window.setTimeout(() => {
      router.push('/admin/login');
    }, 3000); // 3 seconds hold
  };

  const handlePointerUp = () => {
    if (holdTimerRef.current) {
      window.clearTimeout(holdTimerRef.current);
      holdTimerRef.current = null;
    }
  };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('pointerdown', handlePointerDown);
    window.addEventListener('pointerup', handlePointerUp);
    window.addEventListener('pointercancel', handlePointerUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('pointerdown', handlePointerDown);
      window.removeEventListener('pointerup', handlePointerUp);
      window.removeEventListener('pointercancel', handlePointerUp);

      if (holdTimerRef.current) {
        window.clearTimeout(holdTimerRef.current);
        holdTimerRef.current = null;
      }
    };
  }, [router]);
}
